var _style, _path, _defs, _path2, _defs2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKidneyBeans(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 212.6 212.6",
    style: {
      enableBackground: "new 0 0 212.6 212.6"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#F9EFE2;}\n\t.st1{fill:#EF7884;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M106.63,182.83c42.69,0,77.3-34.29,77.3-76.6c0-42.3-34.61-76.6-77.3-76.6s-77.3,34.29-77.3,76.6 C29.33,148.54,63.94,182.83,106.63,182.83"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_7_",
    d: "M102.03,140.8c-1.79-0.27-5.6-0.95-10.12-2.69c-4.82-1.85-7.23-2.78-9.52-4.99 c-1.06-1.03-4.25-4.2-5.01-9.34c-0.97-6.54,2.7-11.4,3.45-12.41c3.61-4.79,8.62-6.23,11.66-7.1c3.19-0.92,5.59-0.96,9.48-1.04 c6.77-0.13,11.94,0.89,15.49,1.62c2.47,0.5,6.38,1.32,11.33,3.16c6.05,2.25,10.23,4.77,11.51,5.56c2.88,1.78,5.44,3.38,8.25,6.26 c1.81,1.85,4.13,4.27,5.64,8.15c1.1,2.81,1.28,5.14,1.33,5.87c0.06,0.95,0.12,3.2-0.58,5.95c-0.48,1.86-1.13,4.37-3.22,6.73 c-2.28,2.56-4.98,3.49-6.69,4.08c-1.04,0.36-3.74,1.19-7.26,1c-1.94-0.11-3.26-0.48-5.72-1.19c-3.42-0.99-4.92-1.76-10.14-3.8 c-3.48-1.36-5.96-2.25-6.96-2.61c-4.97-1.77-7.32-2.41-9.95-2.83C103.46,140.92,103.69,141.05,102.03,140.8z"
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#XMLID_7_",
    style: {
      overflow: "visible",
      fill: "#A6233C"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "XMLID_2_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#XMLID_7_",
    style: {
      overflow: "visible"
    }
  })))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M91.32,116.16c0,0,21.69,3.34,35.15,7.87c4.39,1.48,8.75,3.06,12.99,4.92c1.09,0.48,2.17,0.97,3.23,1.51 c0.49,0.25,1.05,0.68,1.57,0.75c1.29-5.03-4.72-8.67-8.22-10.84c-6.2-3.84-13.09-6.57-20.25-7.96c-3.62-0.7-7.3-1.06-10.99-1.06 c-3.53,0-7.4-0.17-10.77,0.98C92.34,112.93,90.91,114.19,91.32,116.16z"
  })), /*#__PURE__*/React.createElement("g", null, _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000168115625203723803250000009196609380644069309_",
    d: "M87.39,97.04c-1.48,1.04-4.71,3.19-9.17,5.06 c-4.76,2-7.14,3-10.33,2.98c-1.48-0.01-5.97-0.09-10.08-3.27c-5.22-4.05-5.95-10.1-6.1-11.34c-0.71-5.95,1.91-10.46,3.5-13.2 c1.67-2.87,3.37-4.56,6.13-7.31c4.8-4.78,9.24-7.62,12.3-9.55c2.13-1.34,5.52-3.47,10.37-5.56c5.93-2.56,10.69-3.64,12.15-3.95 c3.31-0.71,6.27-1.32,10.29-1.19c2.59,0.08,5.93,0.22,9.71,1.98c2.74,1.27,4.48,2.82,5.02,3.32c0.7,0.65,2.3,2.22,3.7,4.7 c0.94,1.67,2.21,3.94,2.34,7.08c0.13,3.43-1.18,5.97-2.01,7.57c-0.5,0.98-1.87,3.44-4.55,5.74c-1.48,1.27-2.68,1.91-4.95,3.1 c-3.16,1.65-4.77,2.14-9.95,4.28c-3.45,1.42-5.86,2.5-6.83,2.93c-4.81,2.16-6.95,3.33-9.14,4.84 C88.51,96.14,88.76,96.08,87.39,97.04z"
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#XMLID_00000168115625203723803250000009196609380644069309_",
    style: {
      overflow: "visible",
      fill: "#A6233C"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "XMLID_3_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#XMLID_00000168115625203723803250000009196609380644069309_",
    style: {
      overflow: "visible"
    }
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M62.61,86.68c0,0,17.97-12.6,30.82-18.64c4.19-1.97,8.43-3.85,12.79-5.44c1.12-0.41,2.24-0.8,3.38-1.14 c0.52-0.16,1.23-0.24,1.66-0.54c-2.55-4.53-9.41-2.99-13.43-2.14c-7.13,1.51-14,4.31-20.13,8.27c-3.1,2-6.01,4.29-8.66,6.84 c-2.54,2.44-5.46,5-7.1,8.16C61.1,83.64,60.94,85.54,62.61,86.68z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKidneyBeans);
export default __webpack_public_path__ + "static/media/Kidney_beans.52f0105e4fda48125ca700fa60ad1356.svg";
export { ForwardRef as ReactComponent };